<template>
    <div class="hot-words">
        <swiper :options="swiperOptions"
            class="swiper">
            <swiper-slide
                class="swiper__item"
                v-for="(item, index) in newhotWords"
                :key="index">
                <div class="swiper__inner"
                    @click="clickItem(item)">
                    <div class="hot-words__item">
                        {{item}}
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'

    export default {
        name: 'TheHotWords',
        props: {
            hotWords: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                swiperOptions: {
                    slidesPerView: 'auto',
                    spaceBetween: 10
                }
            }
        },
        computed: {
            newhotWords () {
                let arr = this.hotWords.hot_words.split(',')
                return arr
            }
        },
        methods: {
            clickItem (text) {
                // if (type === 'text') {
                //     sendMessage({
                //         type: 'base',
                //         detailType: MESSAGE_NAME.TEXT,
                //         content: text
                //     })
                // } else if (type === 'url') {
                //     window.location.href = url
                // }
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hot-words {
        background-color: #F3F4F6;

        &__item {
            font-size: 14px;
            line-height: 20px;
            color: $primary-text-color;
            text-align: center;
        }

        .swiper {
            /deep/ .swiper-wrapper {
                display: flex;
                padding: 8px 15px;
            }

            &__item {
                width: auto;
            }

            &__inner {
                background: #FFFFFF;
                box-shadow: $primary-box-shadow;
                @include radius(1);
                padding: 5px 12px;
                height: 30px;
                cursor: pointer;

                &:active {
                    color: darken(#5682F8, 20%);
                }
            }
        }
    }
</style>
